import { Injectable } from '@angular/core';
import { CursorType } from '@modules/cursors/types/cursor-type';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CursorService {
  cursor: BehaviorSubject<CursorType> = new BehaviorSubject<CursorType>(null);

  setCursor(cursor: CursorType) {
    this.cursor.next(cursor);
  }
}
